module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAACWTY9zAAAAAXNSR0IArs4c6QAAAGxJREFUSA1jZGBg+A/Egw4wDToXQR006jBSY2Y0xIZNiLFIMLOQ6hm6qGe8Ja82Wo6REtSjuZKU0AKpHQ2xYRNiLBzqP0n1DF3UM/49yzFajpES1KO5kpTQAqkdDbFhE2IsP65yPCLVN/RQDwB0YAogVYwtOQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/German.png
// module id = 470
// module chunks = 7